<template>
  <WhatsHappeningEntriesBox boxItemClass="dark" :entries="entries" :isCurrent="isCurrent" :tellAttendeeToGoToTheMeeting="true" v-if="entries.length > 0"/>
</template>

<script>
import WhatsHappeningEntriesBox from './WhatsHappeningEntriesBox'

export default {
  name: 'WhatsHappeningCurrentEntries',
  props: ['isCurrent', 'entries'],
  components: {WhatsHappeningEntriesBox}
}
</script>
